// TODO: Add all environment variables here & update references
import invariant from 'tiny-invariant';

invariant(process.env.APP_VERSION, 'APP_VERSION must be set');
invariant(
  process.env.CVNA_APP_APIK_BASE_URL,
  'CVNA_APP_APIK_BASE_URL must be set'
);
invariant(process.env.CVNA_APP_ASSETS_CDN, 'CVNA_APP_ASSETS_CDN must be set');
invariant(
  process.env.CVNA_APP_EVENTABLE_ENDPOINT,
  'CVNA_APP_EVENTABLE_ENDPOINT must be set'
);
invariant(process.env.DEPLOY_ENV, 'DEPLOY_ENV must be set');

export const environment = process.env.DEPLOY_ENV as 'dev' | 'test' | 'prod';

export const isLocalEnvironment = Boolean(process.env.IS_LOCAL);

export const isProd: boolean = environment === 'prod';

export const isNonProd: boolean =
  environment === 'dev' || environment === 'test';

const commonEnvironmentMapping = {
  dev: 'development',
  test: 'test',
  prod: 'production'
};

export const commonEnvironment: any = commonEnvironmentMapping[environment];

export const apikUrl: string = process.env.CVNA_APP_APIK_BASE_URL;

export const applicationVersion: string = process.env.APP_VERSION;

export const assetsUrl: string = process.env.CVNA_APP_ASSETS_CDN;

export const eventableEndpoint: string =
  process.env.CVNA_APP_EVENTABLE_ENDPOINT;
